import styles from './SearchPage.module.css';
import cn from 'classnames';

type Props = {
	order: 'messagesCount' | 'createdAt';
	onChange: (order: 'messagesCount' | 'createdAt') => void;
};

export const SearchOrder = ({order, onChange}: Props) => {
	return (
		<div className={styles.searchOrder}>
			<div
				className={cn(styles.searchOrderItem, order === 'messagesCount' && styles.active)}
				onClick={() => onChange('messagesCount')}
			>
				Popular
			</div>
			<div
				className={cn(styles.searchOrderItem, order === 'createdAt' && styles.active)}
				onClick={() => onChange('createdAt')}
			>
				Newest
			</div>
		</div>
	);
};
